import { fetchAuthApi } from '@/api/client';
import type {
  SiteCctvMember,
  SiteCctvMemberCreate,
  SiteCctvMembersResponse,
  SiteCctvMemberUpdate,
} from '@/types/site-members';

const membersPath = (siteId: string) => `/v1/sites/${encodeURIComponent(siteId)}/cctv-roles`;

export function getSiteCctvMembers(siteId: string): Promise<SiteCctvMembersResponse> {
  return fetchAuthApi<SiteCctvMembersResponse>(membersPath(siteId));
}

export function assignSiteCctvMember(
  siteId: string,
  data: SiteCctvMemberCreate,
): Promise<SiteCctvMember> {
  return fetchAuthApi<SiteCctvMember>(membersPath(siteId), {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export function updateSiteCctvMember(
  siteId: string,
  userId: string,
  data: SiteCctvMemberUpdate,
): Promise<SiteCctvMember> {
  return fetchAuthApi<SiteCctvMember>(`${membersPath(siteId)}/${encodeURIComponent(userId)}`, {
    method: 'PATCH',
    body: JSON.stringify(data),
  });
}

export function revokeSiteCctvMember(
  siteId: string,
  userId: string,
  expectedVersion: number,
): Promise<void> {
  return fetchAuthApi<void>(
    `${membersPath(siteId)}/${encodeURIComponent(userId)}?expected_version=${expectedVersion}`,
    { method: 'DELETE' },
  );
}
